import React from 'react';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { FiltersParams } from 'types/params';
import ActiveFilter from '../components/ActiveFilter';
import { TagItem } from '../styled';

const getActiveBpm = (
    bpmlowerbound: string | null,
    bpmupperbound: string | null,
    removeFilter: (modifiers: ModifiersPayload[]) => void,
) => {
    if (!bpmlowerbound) {
        return null;
    }

    const isExactValue = bpmlowerbound === bpmupperbound;
    const exact = `${bpmlowerbound} BPM`;
    const range = `${bpmlowerbound} - ${bpmupperbound} BPM`;

    const normalizedFilter = isExactValue ? exact : range;

    return (
        <TagItem
            key={`filter-${FiltersParams.bpmlowerbound}-${normalizedFilter}`}
        >
            <ActiveFilter
                onClick={() =>
                    removeFilter([
                        [FiltersParams.bpmlowerbound, bpmlowerbound],
                        [FiltersParams.bpmupperbound, bpmupperbound],
                    ])
                }
                filter={normalizedFilter}
            />
        </TagItem>
    );
};

export default getActiveBpm;
